import { routerApp } from '../app.module';

export interface Port {
    name: string,
    country: string,
    country_code: string,
    latitude: number,
    longitude: number,
    code?: string,
    eea?: boolean,
    is_eu?: boolean,
    is_omr?: boolean,
    is_uk?: boolean,
    is_transhipment?: boolean,
    is_fueleu?: boolean,
}

routerApp.controller('managementPortsController', ['PortService', '$rootScope', '$scope', 'notify', '$state',
    function (PortService, $rootScope, $scope, notify, $state) {
        
    $rootScope.selectedLevels = ['management', 'ports'];
    $scope.pageState.pageTitle = 'View Ports';

    $scope.resetPort = function () {
        $scope.errorMessage =''
        $scope.customPort = {
            name: '',
            country: '',
            country_code: '',
            fueleu_code: '',
            latitude: null,
            longitude: null,
            code: null,
            eea: false,
            is_eu: false,
            is_omr: false,
            is_uk: false,
            is_transhipment: false,
            is_fueleu: false,
        }
    }

    $scope.errorMessage = ''
    $scope.successMessage = ''
    $scope.customPort = {}
    $scope.resetPort();

    $scope.savePort = function () {
        $scope.errorMessage = '';
        $scope.successMessage = ''

        const res = validatePort($scope.customPort)

        if (res) return $scope.errorMessage = res

        PortService.saveCustomPort($scope.customPort).then(function(response) {
            if (response?.status === 200) {
                $scope.resetPort();
                return $scope.successMessage = 'Port Submitted'
            }
    
            return $scope.errorMessage = 'Error submitting new port'
        }).catch((err) => {
            console.log('Error saving port ', err);

            if (err.status === 400 && err?.data?.message) return $scope.errorMessage = err?.data?.message;
            return $scope.errorMessage = 'Error submitting new port';
        })
    }
}]);


function validatePort (port): string {
    const { 
        name,
        code,
        country,
        country_code,
        latitude,
        longitude,
    } = port

    if (!port) return 'No Port Found'
    if (!name) return 'Port name is required.'
    if (!country) return 'Country is required.'
    if (!country_code) return 'Country code is required.'
    if (!latitude && latitude !== 0) return 'Latitude is required.'
    if (latitude < -90 || latitude > 90) return 'Latitude must be within range -90 to 90.'
    if (!longitude && longitude !== 0) return 'Longitude is required.'
    if (longitude < -180 || longitude > 180) return 'Longitude must be within range -180 to 180.'
    if (code && code.length !== 5) return 'UNLOCODE is not required but if entered, must be exactly five characters long.'

    return ''
}